import { defineComponent, reactive, ref, watch, toRefs, onMounted, nextTick, onBeforeUnmount } from "vue";
import * as echarts from "echarts";
export default defineComponent({
  components: {},
  name: "",
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '100%'
    },
    title: {
      type: String,
      default: ''
    },
    chartData: {
      type: Object,
      default: () => {}
    },
    color: {
      type: Array,
      default: () => []
    }
  },
  setup(props) {
    let myEcharts = ref(null);
    let myChart = null;
    const state = reactive({
      option: null
    });
    const methods = reactive({});
    const setOptions = ({
      legend,
      series,
      xaxis
    } = {}) => {
      state.option = {
        tooltip: {},
        grid: {
          top: '0',
          left: '-10%',
          right: '0',
          bottom: '8%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: true,
          axisLine: {
            //坐标轴轴线相关设置。数学上的x轴
            show: true,
            lineStyle: {
              color: '#f9f9f9'
            }
          },
          axisLabel: {
            //坐标轴刻度标签的相关设置
            textStyle: {
              color: '#d1e6eb',
              margin: 15
            }
          },
          axisTick: {
            show: false
          },
          data: ['1', '2', '3', '4', '5', '6', '7']
        }],
        yAxis: [{
          type: 'value',
          min: 0,
          show: false
        }],
        series: [{
          name: '注册总量',
          type: 'line',
          // smooth: true, //是否平滑曲线显示
          // 			symbol:'circle',  // 默认是空心圆（中间是白色的），改成实心圆
          showAllSymbol: true,
          symbol: 'emptyCircle',
          symbolSize: 6,
          lineStyle: {
            normal: {
              color: "#28ffb3" // 线条颜色
            },
            borderColor: '#f0f'
          },
          label: {
            show: true,
            position: 'top',
            textStyle: {
              color: '#fff'
            }
          },
          itemStyle: {
            normal: {
              color: "#28ffb3"
            }
          },
          tooltip: {
            show: false
          },
          areaStyle: {
            //区域填充样式
            normal: {
              //线性渐变，前4个参数分别是x0,y0,x2,y2(范围0~1);相当于图形包围盒中的百分比。如果最后一个参数是‘true’，则该四个值是绝对像素位置。
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(0,154,120,1)'
              }, {
                offset: 1,
                color: 'rgba(0,0,0, 0)'
              }], false),
              shadowColor: 'rgba(53,142,215, 0.9)',
              //阴影颜色
              shadowBlur: 20 //shadowBlur设图形阴影的模糊大小。配合shadowColor,shadowOffsetX/Y, 设置图形的阴影效果。
            }
          },
          data: [393, 438, 485, 631, 689, 824, 987]
        }, {
          name: '最新注册量',
          type: 'bar',
          barWidth: 20,
          tooltip: {
            show: false
          },
          label: {
            show: true,
            position: 'top',
            textStyle: {
              color: '#fff'
            }
          },
          itemStyle: {
            normal: {
              // barBorderRadius: 5,
              // color: new echarts.graphic.LinearGradient(
              //     0, 0, 0, 1,
              //     [{
              //             offset: 0,
              //             color: '#14c8d4'
              //         },
              //         {
              //             offset: 1,
              //             color: '#43eec6'
              //         }
              //     ]
              // )
              color: function (params) {
                var colorList = ['#0ec1ff', '#10cdff', '#12daff', '#15ebff', '#17f8ff', '#1cfffb', '#1dfff1'];
                return colorList[params.dataIndex];
              }
            }
          },
          data: [200, 382, 102, 267, 186, 315, 316]
        }]
      };
      myChart.setOption(state.option);
    };
    onMounted(() => {
      nextTick(() => {
        myChart = echarts.init(myEcharts.value);
        setOptions(props.chartData);
      });
    });
    window.addEventListener('resize', () => {
      myChart.resize();
    });
    onBeforeUnmount(() => {
      destroy();
    });
    const destroy = () => {
      if (!myChart) {
        return;
      }
      myChart.dispose(); //销毁
    };
    watch(() => props.chartData, () => {
      if (myChart) {
        myChart.clear();
      }
      setOptions(props.chartData);
    }, {
      deep: true
    });
    return {
      ...toRefs(state),
      ...toRefs(methods),
      setOptions,
      myEcharts,
      destroy
    };
  }
});